import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Paggination/Paggination";
import Select from "../../components/Select/";
import { addInfo, getInfo } from "../../redux/actions/info";
import Filter from "./Filter/Filter";

const sortOtions = [
  { id: "publishedAt", value: "За датою опублікування" },
  { id: "title", value: "За абеткою" },
];

const InfoListPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [intervalId,setIntervalId] = useState(null);  const [ready, setReady] = useState(false);
  const [modal, setModal] = useState(false);
  const [sortData, setSortData] = useState("publishedAt");
  const [sortName, setSortName] = useState("За датою опублікування");
  const [sortValue, setSortValue] = useState("desc");
  const { listId } = useSelector((state) => state);
  const { info } = useSelector((state) => state);

  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState(false);
  const [filterArr, setFilterArr] = useState({});

  const searchChange = (e) => {
    let filter = {};
    setSearchValue(e.target.value);
    if (localStorage.getItem("infoFilter")) {
      filter = JSON.parse(localStorage.getItem("infoFilter"));
    }
    filter.all = [];


      clearTimeout(intervalId);
    const newIntervalId = setTimeout(() =>{
      // Call your search function with the updated query value
    
      if (e.target.value.length > 2) {
        filter.all[0] = e.target.value;
        localStorage.setItem("infoFilter", JSON.stringify(filter));
        getInfoList(1, filter);
      } else {
        localStorage.setItem("infoFilter", JSON.stringify(filter));
        getInfoList(1, filter);
      }
    }, 1000)
    setIntervalId(newIntervalId);  ;


   
  };

  const AddInfo = (e) => {
    setReady(false);
    e.preventDefault();
    dispatch(addInfo())
      .then((res) => {
        navigate(`/infoedit/${res.id}`);
      })
      .catch((e) => {
        console.log(e);
      });
  };
  const sortClick = (e) => {
    setSortName(e.target.innerHTML);
    const currentIdIndex = sortOtions.findIndex(
      (x) => x.value === e.target.innerHTML
    );
    setSortData(sortOtions[currentIdIndex].id);
    let data = {};
    if (sortData === sortOtions[currentIdIndex].id && sortValue === "asc") {
      setSortValue("desc");
      data[sortOtions[currentIdIndex].id] = "desc";
    } else {
      data[sortOtions[currentIdIndex].id] = "asc";
      setSortValue("asc");
    }
    localStorage.setItem("infoSort", JSON.stringify(data));
    getInfoList();
    setModal(false);
  };

  const getInfoList = (page = 1, filter) => {
    let data = {};
    if (filter) {
      data.filter = { ...filter };
    } else {
      if (localStorage.getItem("infoFilter")) {
        data.filter = { ...JSON.parse(localStorage.getItem("infoFilter")) };
      } else {
        data.filter = {};
      }
    }
    if (localStorage.getItem("infoSort")) {
      data.sort = { ...JSON.parse(localStorage.getItem("infoSort")) };
    } else {
      data.sort = { updatedAt: "asc" };
    }
    data.offset = (page - 1) * 10;
    data.limit = 10;
    dispatch(getInfo(data)).then((res) => {
      setReady(true);
    });
  };
  const resetFilter = () => {
    localStorage.removeItem("infoFilter");
    setFilterArr({});
    getInfoList();
  };

  useEffect(() => {
    if (!ready) {
      if (localStorage.getItem("infoFilter")) {
        let filter = JSON.parse(localStorage.getItem("infoFilter"));
        getInfoList(1, filter);
        setFilterArr(filter);
      } else {
        getInfoList();
      }
    }
  }, [ready]);

  if (!ready || !info.items || !listId.list) {
    return (
      <div style={{ position: "relative" }}>
        {" "}
        <div style={{ position: "absolute", top: "50%", left: "50%" }}>
          <Loader />
        </div>{" "}
      </div>
    );
  } else if (ready && info.items && listId.list) {
    return (
      <>
        {filter && (
          <Filter
            setModal={setFilter}
            getInfoList={getInfoList}
            setFilter={setFilterArr}
          ></Filter>
        )}
        <div className="headerWithButtonsCommonBlock">
          <div className="headerWithButtonsHeaderBlock">
            <h1>База знань</h1>
          </div>
          <div className="headerWithButtonsButtonBlock">
            {searchOpen && (
              <div style={{ marginBottom: "4px" }} className="apInputText">
                <label htmlFor="search">Пошук</label>
                <input
                  id="search"
                  type="text"
                  placeholder="Мінімум 3 символи"
                  value={searchValue}
                  onChange={searchChange}
                />
              </div>
            )}
            <button
              className="secondaryButtonIconDefault"
              onClick={() => setSearchOpen(!searchOpen)}
            >
              <svg>
                <use href="/images/icon24Search.svg#icon24" />
              </svg>
            </button>
          </div>
        </div>
        <div className="sortAndFilterBlock">
          <div className="menuFunctionLine">
            <div className="actionButtonsBlock">
              <button
                className="primaryButtonIconTextDefault"
                onClick={AddInfo}
              >
                <svg>
                  <use href="/images/icon24Plus.svg#icon24" />
                </svg>
                Додати запис
              </button>
              <div className="filterBlock">
                <button
                  className="secondaryButtonIconTextDefault"
                  onClick={() => setFilter(true)}
                >
                  <svg>
                    <use href="/images/icon24Filter.svg#icon24" />
                  </svg>
                  Фільтр
                </button>
                <span>Знайдено {info.total} записів:</span>
                {filterArr &&
                  Object.keys(filterArr).length > 0 &&
                  Object.keys(filterArr).map((el) => {
                    return (
                      filterArr[el].length > 0 &&
                      filterArr[el].map((elem, index) => {
                        return (
                          <div className="apChips" key={index}>
                            {listId.list[elem]}
                            {/* <svg><use href="/images/icon24CancelSmall.svg#icon24" /></svg> */}
                          </div>
                        );
                      })
                    );
                  })}
                {filterArr && Object.keys(filterArr).length > 0 && (
                  <button
                    onClick={resetFilter}
                    className="secondarySmallRoundedButtonTextDefault"
                  >
                    Скинути
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="sortBlock">
            <Select
              label={"Сортування:"}
              value={sortName}
              options={sortOtions}
              onSet={sortClick}
            />
          </div>
        </div>

        <div className="pageContentHeaderDivider" />
        <div className="dictAllRowsContainer">
          {info &&
            info.items &&
            info.items.length > 0 &&
            info.items.map((el, index) => {
              return (
                <div key={index} className="catVideosRowNormal">
                  <div className="catVideoValue">
                    {listId.list[el.sectionId]}
                  </div>

                  <div
                    className="catVideoValue"
                    onClick={() => navigate(`/infoedit/${el.id}`)}
                  >
                    {el.title}
                  </div>

                  <div className="catVideoValue">
                    {listId.list[el.statusId]}
                  </div>
                </div>
              );
            })}
        </div>
        {info.total > 10 && (
          <Pagination
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={info.total.toFixed(0)}
            pageSize="10"
            onPageChange={async (page) => {
              await setCurrentPage(page);
              await getInfoList(page);
            }}
          />
        )}
      </>
    );
  }
};

export default InfoListPage;
